import { useLocation } from 'react-router-dom';

const LOCAL_STORAGE_KEY = 'meta-integration-connected';

/**
 * TODO: Remove this hook once Meta integration is fully implemented.
 * This is a temporary developer utility to test post-connection UI without
 * a real Meta connection. Use `?connected=true` query param or set
 * `meta-integration-connected=true` in localStorage to simulate connected state.
 */
export function useMetaConnectionToggle(): boolean {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const queryParam = searchParams.get('connected');
  if (queryParam === 'true') {
    return true;
  }

  if (typeof window !== 'undefined') {
    const localStorageValue = localStorage.getItem(LOCAL_STORAGE_KEY);
    return localStorageValue === 'true';
  }

  return false;
}
